export const PRICE_INDEX_OZON_ONBOARDING_CLOSE_LIMIT = 2;
// Рабочее правило: следующий показ разрешён не раньше чем через 24 часа после закрытия.
export const PRICE_INDEX_OZON_ONBOARDING_SHOW_INTERVAL_MS = 24 * 60 * 60 * 1000;
export const PRICE_INDEX_OZON_ONBOARDING_STORAGE_KEY = 'priceIndex.ozonOnboarding';
